import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Alert from 'components/Alert';
import DateOfServiceError from 'products/nomad_insurance/views/ClaimsForm/components/DateOfServiceError';

const StyledAlert = styled(Alert)`
  margin-top: 16px;
`;

const ContractIDError = ({ error, isVisible }) => {
  if (!isVisible) {
    return null;
  }
  if (error?.message === 'No contract found for given Date of Service') {
    return <DateOfServiceError />;
  }

  return (
    <StyledAlert variant="danger" label="Something went wrong">
      Something went wrong with fetching your insurance information. Please try again, and
      if the problem persists, contact customer service.
    </StyledAlert>
  );
};

ContractIDError.propTypes = {
  error: PropTypes.object,
  isVisible: PropTypes.bool
};

export default ContractIDError;
